module.exports = __webpack_public_path__ + "media/demo_video.c19a6414.mp4";